function storedHandler(send: (p: any) => void, res: { message: { id: number; temporalId: number; } }) {
  const messages = this.config.inbox.messages;

  messages.replace(res.message.temporalId, res.message.id);
  messages.add(res.message);
}

export default storedHandler;
